import { gql } from "@apollo/client";

const schema = {
  delete: {
    name: "deletePlan",
    serviceName: "admin",
    query: gql`
      mutation deletePlan($ids: [String]!) {
        deletePlan(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
